import React from "react";
import CIcon from "@coreui/icons-react";
import { 
  CSidebarNav, 
  CSidebarNavItem, 
  CSidebarNavDropdown, 
  CSidebarNavTitle, 
  CSidebarNavDivider 
} from "@coreui/react";

import {
  BsGrid3X3GapFill,
  BsFillPlusSquareFill,
  BsGear,
  BsListTask,
} from "react-icons/bs";

const _nav = [
  {
    _tag: "CSidebarNavItem",
    name: "Dashboard",
    to: "/dashboard",
    icon: <BsGrid3X3GapFill customclasses="custom-bootstrap-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavTitle",
    _children: ["Core Modules"],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "TTS Projects",
    route: "/articles",
    icon: <BsFillPlusSquareFill customclasses="custom-bootstrap-sidebar-nav-icon" />,
    children: [
      {
        _tag: "CSidebarNavItem",
        name: "Publishers",
        to: "/publishers",
        icon: "cil-user-plus",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Advertisers",
        to: "/advertisers",
        icon: "cil-user-plus",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Articles",
        route: "/articles",
        to: "/articles",
        icon: "cil-link",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Website",
        to: "/website",
        icon: "cil-library",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Widget UI",
        to: "/widget-ui",
        icon: "cil-library",
      },
    ],
  },
  {
    _tag: "CSidebarNavDivider",
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Other Projects",
    route: "/other-projects",
    icon: <BsFillPlusSquareFill customclasses="custom-bootstrap-sidebar-nav-icon" />,
    children: [
      {
        _tag: "CSidebarNavItem",
        name: "Projects",
        to: "/projects",
        icon: "cil-user-plus",
      },
    ],
  },
  {
    _tag: "CSidebarNavDivider",
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Demands",
    route: "/demand",
    icon: <BsFillPlusSquareFill customclasses="custom-bootstrap-sidebar-nav-icon" />,
    children: [
      {
        _tag: "CSidebarNavItem",
        name: "Endpoints",
        to: "/demand",
        icon: "cil-plus",
      },
    ],
  },
  {
    _tag: "CSidebarNavDivider",
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "ADs",
    route: "/ads",
    icon: <BsFillPlusSquareFill customclasses="custom-bootstrap-sidebar-nav-icon" />,
    children: [
      {
        _tag: "CSidebarNavItem",
        name: "Ads",
        to: "/ads",
        icon: "cil-plus",
      },
    ],
  },
 
  {
    _tag: "CSidebarNavTitle",
    _children: ["Core Settings"],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Settings",
    route: "/settings",
    icon: <BsGear customclasses="custom-bootstrap-sidebar-nav-icon" />,
    children: [
      {
        _tag: "CSidebarNavItem",
        name: "Users",
        to: "/users",
        icon: "cil-user-plus",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Roles",
        to: "/roles",
        icon: "cil-plus",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Modules",
        to: "/modules",
        icon: "cil-playlist-add",
      },
    ],
  },
  {
    _tag: "CSidebarNavItem",
    name: "Profile",
    icon: "cil-user",
    to: "profile",
    route: "profile",
  },
  {
    _tag: "CSidebarNavDivider",
    className: "m-2",
  },
];

export default _nav;
